export class DashboardBannerItem {
    public iconPath: string;
    public iconWidth: number;
    public iconHeight: number;
    public title: string;
    public text: string;

    constructor(iconPath: string, iconWidth: number, iconHeight: number, title: string, text: string) {
        this.iconPath = iconPath;
        this.iconWidth = iconWidth;
        this.iconHeight = iconHeight;
        this.title = title;
        this.text = text;
    }
}
